import { useLang } from "@/context/LangContext";
import ShareImageButton from "@/components/ShareImageButton";
import ShareSeatCard from "@/components/ShareSeatCard";

export default function ShareSeatButton({ seat, eduText, wealthText, wealthExtra, fateText }) {
  const { t, lang } = useLang();
  const url = `${window.location.origin}/c/${encodeURIComponent(seat.tn1_name || seat.name)}`;
  return (
    <ShareImageButton
      className="mt-4"
      testid="seat-share-btn"
      url={url}
      text={t("share_seat_msg").replace("{seat}", lang === "ta" ? seat.name_ta : seat.name)}
      fileName={`neeyosi-${seat.name.replace(/\W+/g, "-").toLowerCase()}-2021-vs-2026.png`}
      card={<ShareSeatCard seat={seat} t={t} lang={lang} eduText={eduText} wealthText={wealthText} wealthExtra={wealthExtra} fateText={fateText} url={url} />}
    />
  );
}
